import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'db-environment-banner',
  templateUrl: './environment-banner.component.html',
  styleUrls: ['./environment-banner.component.scss']
})
export class EnvironmentBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
